import React, { useState, useEffect } from 'react';

const EditableField =  ({ text, className, saveClickObserver } : {text:string; className:string; saveClickObserver:(value:any)=>void}) => {
  const [currentText, setCurrentText] = useState(text);

  useEffect(() => {
    if (text) {
      setCurrentText(text);
    }
  }, [text]);

  useEffect(() => {
    setCurrentText(text);
  }, []);

  // tentative
  useEffect(() => {
    if (saveClickObserver) {
      // run the function, passing the current state
      saveClickObserver(currentText);
    }
  }, [saveClickObserver]);

  const handleTextChange = (event:React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.value !== ' ') {
      setCurrentText(event.target.value);
    }
  };

  return (
    <label className="pp-ww">
      <input
        type="text"
        className={className}
        value={currentText ? currentText : ''}
        onChange={event => handleTextChange(event)} />
    </label>
  );
};
export default EditableField;
